<template>
  <dialog-frame :title="$t('unlink-enode-user-dialog.title').toString()"
                icon="hub"
                color="primary"
                closable
                @close="abort">
    <template v-slot:content>
      {{ $t('unlink-enode-user-dialog.text') }}
    </template>

    <template v-slot:actions>
      <v-btn plain block
             color="primary"
             class="font-weight-bold d-block"
             @click="unlinkUser">
        {{ $t('unlink-enode-user-dialog.button') }}
      </v-btn>
    </template>
  </dialog-frame>
</template>

<script>

import DialogFrame from "@/templates/dialogs/DialogFrame";
export default {
  name: 'UnlinkEnodeUserDialog',

  components: {
    DialogFrame
  },

  methods: {
    unlinkUser() {
      this.$root.$emit('unlinkUser')
      this.$root.bisadialog.toggle('unlinkEnodeUser')
    },
    abort() {
      this.$root.bisadialog.toggle('unlinkEnodeUser')
    }
  },

};
</script>

